import { getActingUser } from '../user/userApi';
import { notificationsApi } from '../notifications/notificationsApi';

export const getClientIdFilters = (client) =>
	client?.docId ? `clientDocId:="${client.docId}"` : undefined;

// clientId here is the client's Firestore doc id
export const getClientIdFilterFromId = (clientId) => {
	if (clientId == null) return undefined;

	return `clientDocId:="${clientId}"`;
};

// A generic id (e.g. a task's clientId field) is the client's doc id.
export const clientMatchesGenericId = (client, id) =>
	id != null &&
	(client?.id?.toString() === id?.toString() ||
		client?.clientId?.toString() === id?.toString());

export const clientMatchesDeal = (client, deal) =>
	deal?.clientDocId != null &&
	(client?.id?.toString() === deal.clientDocId?.toString() ||
		client?.clientId?.toString() === deal.clientDocId?.toString());

export const createClientAssignedNotification = async ({
	dispatch,
	getState,
	clientId,
	assigneeDocId,
}) => {
	if (!clientId || !assigneeDocId) return;

	try {
		const userData = await getActingUser(dispatch, getState);

		if (String(userData?.userId) === String(assigneeDocId)) return;

		await dispatch(
			notificationsApi.endpoints.createNotification.initiate({
				clientId,
				action: 'assigned',
			}),
		).unwrap();
	} catch (err) {
		console.log('Error creating client assignment notification', err);
	}
};
